import * as yup from 'yup'

import { 
    trimmedInputValues,
    capitalizeWordsInValue,
} from '../utils';

const oneYearFromNow = new Date(new Date())
oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1)

const BuyerRateContractValidation = yup.object().shape({
    branchId: yup.number().required("Please select branch"),
    companyERPCode: yup.string().transform((value) => trimmedInputValues(value)),
    materialId: yup.string().transform((value) => trimmedInputValues(value)),
    companyProdName: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .min(3, 'Product name must be at least 3 characters')
        .required('Please enter product name')
        .transform((value) => trimmedInputValues(value)),
    companyProdSpec: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .min(3, 'Product specifications must be at least 3 characters')
        .required('Please enter product specifications')
        .transform((value) => trimmedInputValues(value)),
    companyERPCategory: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .required('Please enter ERP Category')
        .transform((value) => trimmedInputValues(value)),
    companyERPUOM: yup.string()
        .required('Please enter ERP UOM')
        .transform((value) => trimmedInputValues(value)),
    companyHSNOverride: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter HSN'),
    companyGSTOverride: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter GST'),
    /*
    UNSPSC: yup.string()
        .transform((value) => trimmedInputValues(value)),
    */
    unitPrice: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter unit price'),
    leadTime: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter lead time'),
    validityPeriod: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please select validity period'),
    make: yup.string()
        .transform((value) => trimmedInputValues(value))
        .nullable(),
    monthlyQty: yup.string()
        .transform((value) => trimmedInputValues(value))
        .nullable(),
    monthlyValue: yup.string()
        .transform((value) => trimmedInputValues(value))
        .nullable()
});

const initialBuyerRateContractDetails = {
    branchId: null,
    companyERPCode: null,
    materialId: "",
    companyProdName: "", 
    companyProdSpec: "",
    companyERPCategory: "",
    companyERPUOM: "",
    companyHSNOverride: "",
    companyGSTOverride: "",
    UNSPSC: "",
    unitPrice: "",
    leadTime: "",
    validityPeriod: oneYearFromNow,
    rateContractTypeId: 1,
    minOrderQty: null,
    make: null,
    monthlyQty: null,
    monthlyValue: null
}


export { BuyerRateContractValidation, initialBuyerRateContractDetails }